export const LOGIN = "/auth/login";
export const LOGOUT = "/auth/logout";
export const FORGET_PASSWORD = "/auth/forgot-password";
export const RESET_PASSWORD = "/auth/reset-password";
export const PROFILE = "/auth/profile";
export const PASS_CHANGE = "/auth/change-password";
export const SUB_DISTRIBUTOR = "/sub-distributor";
export const ACCOUNT = "/account";
export const LOAN = "/loan";
export const DEPOSIT = "/deposit";
export const UPLOAD = "/auth/upload-image";
export const TERMS_CONDITIONS = "/auth/terms-conditions";
export const BUSINESS_DETAIL = "/auth/business-detail";
export const EXPENSE = "/expense";